import { Component, OnInit } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SessionService } from '@app/shared/services/session.service';
import { Router } from '@angular/router';
import { MenuService } from '@app/shared/services/menu.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loginForm;
  public release: string  = environment.release;
  public testMode: boolean = environment.testMode;
  public devMode: boolean  = !environment.production;

  constructor(
    private titleService: TitleService,
    private formBuilder: FormBuilder,
    private sessionService: SessionService,
    private menu: MenuService,
    private router: Router
  ) {
    if (this.sessionService.isSigned === true) {
      this.router.navigateByUrl(`/`);
    }
  }

  ngOnInit() {
    this.titleService.setTitle(`Connectez-vous sur VOP`);
    this.menu.setMenuState('login', '', '');
    this.loginForm = this.formBuilder.group({
      username: '',
      password: ''
    });
  }

  login(credentials) {
    this.sessionService.login(credentials.username, credentials.password);
  }

}
